import { useQuery } from "@tanstack/react-query";
import { instance } from "api/apiBase";

export interface ApplicationFilterOptions {
  cities?: { city: string; count: number }[];
  properties?: { id: string; name: string; count: number }[];
  statuses?: { status: string; count: number }[];
  /** property_name is set on the partner-wide list, where unit titles repeat across properties. */
  units?: {
    id: string;
    title: string;
    property_name?: string;
    count: number;
  }[];
  states?: { state: string; count: number }[];
  unit_types?: { unit_type: string; count: number }[];
  screening_statuses?: { status: string; count: number }[];
  unit_statuses?: { status: string; count: number }[];
  property_groups?: { id: string; name: string; count: number }[];
  stages?: { id: number; name: string; color?: string; count: number }[];
}

const FILTER_OPTIONS_QUERY = "/portal/v1/applications/filter_options";

export const APPLICATION_FILTER_OPTIONS_QUERY_KEY =
  "APPLICATION_FILTER_OPTIONS";

export const applicationFilterOptionsQueryKey = (params: {
  unitId?: number;
  propertyId?: number;
}) => [
  APPLICATION_FILTER_OPTIONS_QUERY_KEY,
  { unit_id: params.unitId, property_id: params.propertyId }
];

// Shared by the Filters drawer and the column header filters, so both list the same options
// from one cached request.
export const useApplicationFilterOptions = ({
  unitId,
  propertyId,
  enabled = true
}: {
  unitId?: number;
  propertyId?: number;
  enabled?: boolean;
}) =>
  useQuery({
    queryKey: applicationFilterOptionsQueryKey({ unitId, propertyId }),
    queryFn: () =>
      instance
        .get(FILTER_OPTIONS_QUERY, {
          params: { unit_id: unitId, property_id: propertyId }
        })
        .then(({ data }: { data: ApplicationFilterOptions }) => data),
    enabled
  });
